import React from 'react';
import { motion } from 'framer-motion';
import { GlassCard } from '../GlassCard';
import { GlassCTA } from '../GlassCTA';

interface HookStepProps {
  onComplete: () => void;
}

export function HookStep({ onComplete }: HookStepProps) {
  return (
    <GlassCard>
      <div className="flex flex-col items-center text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="mb-6 flex h-14 w-14 items-center justify-center rounded-full"
          style={{
            background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.25), rgba(139, 92, 246, 0.15))',
            border: '1px solid rgba(255, 255, 255, 0.15)',
          }}
        >
          <span className="text-2xl">&#x2728;</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="text-[28px] font-semibold text-white tracking-tight"
          style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)' }}
        >
          You're all set.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          className="mt-5 text-lg leading-relaxed"
          style={{ color: 'rgba(255, 255, 255, 0.7)' }}
        >
          Your boards are ready. Drop ideas, notes, and files onto your canvas
          — I'll help keep everything organized.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.6 }}
          className="mt-10"
        >
          <GlassCTA onClick={onComplete}>Enter your workspace</GlassCTA>
        </motion.div>
      </div>
    </GlassCard>
  );
}
